/**
 * Project Frontend Application scripts
 *
 * @author Matej Svajger <hello@matejsvajger.com>
 */

/* global $ */

import Vue          from 'vue'
import AOS          from 'aos'
import { library as fontlib } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faSpinner } from '@fortawesome/free-solid-svg-icons/faSpinner'
import { faCheck } from '@fortawesome/free-solid-svg-icons/faCheck'
import clone from 'lodash/cloneDeep'

// eslint-disable-next-line
import Language from '../language'

import cretaeStore  from '../store'

import Xhr          from '@Core/xhr'
import Events       from '@Core/events'
import Dispatcher   from '@Core/dispatcher'
import components   from '@Components'
import Breakpoints  from '@Utils/breakpoints'
import IsScrolling  from '@Utils/isScrolling'
import Module       from '@Modules'
import containedIn  from '@Utils/contained-in'
import Paypal       from '@Utils/paypal'

import ProductPreview from '@Components/product/ProductPreview'
import UserLogin from '@Components/user-popup/UserLogin'
import UserProfileMenu from '@Components/user-popup/UserProfileMenu'
import FavoritesProductEdit from '@Components/favorites-products/FavoritesProductEdit'

fontlib.add(faCheck)
fontlib.add(faSpinner)

Vue.use(Language)
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.config.productionTip = false

export default class {
  constructor () {
    this.xhr = Xhr
    this.event = Events
    this.dispatcher = new Dispatcher()
    this.paypal = new Paypal()
  }

  init (url, locale, messages) {
    this.url = url

    let el = '#app'
    let topLayer = '#top-layer'

    window.INITIAL_STATE = window.INITIAL_STATE || {}
    let lang = new Language(locale, messages)
    this.lang = lang
    let store = cretaeStore(clone(window.INITIAL_STATE))

    this.vue = new Vue({
      el, lang, url, store, components
    })

    this.topLayer = new Vue({
      url,
      lang,
      store,
      el: topLayer,
      components: {
        ProductPreview,
        UserLogin,
        UserProfileMenu,
        FavoritesProductEdit
      }
    })

    this.modules = [
      new IsScrolling('body'),
      new Module.OffCanvas('#offcanvas'),
      new Module.OffCanvasNew('#offcanvasNew'),
      new Module.Footer(),
      new Module.Product(),
      // new Module.ElasticImage(document.querySelector('#product-image')),
      new Module.Slider(
        document.querySelector('.product-images'),
        document.querySelectorAll('#productImages .control')
      ),
      new Module.AddToCartButton(),
      new Module.ProductPreview(),
      new Module.UserLogin(),
      new Module.UserProfileMenu(),
      new Module.FavoritesProductEdit(),
      new Module.RegisterForm(),
      //new Module.NewsletterPopup(),
      new Breakpoints()
    ]

    AOS.init()

    this.favoritesData()
    this.handleGlobalClicks()

    $('#confirm-form .btn-confirm').on('click', function (e) {
      e.preventDefault()
      e.stopPropagation()

      $(this)
        .attr('disabled', true)
        .closest('form')
        .submit()

      return false
    })

    window.ElasticImage = Module.ElasticImage

    this.inview = new Module.InView();

    this.inview.observe('div[data-popular]', (el) => {
      let numberOfItems = el.dataset.popular;
      if(numberOfItems > 0) {
        setTimeout( function() { 
          document.getElementById('popItem1').classList.add('pos1');
          document.getElementById('popItem1').classList.remove('posLeftOut');
        },500);
      }
      if(numberOfItems > 1) {
        document.getElementById('popItem2').classList.add('pos2');
        document.getElementById('popItem2').classList.remove('posLeftOut');
      }
      if(numberOfItems > 2) {
        document.getElementById('popItem3').classList.add('pos3');
        document.getElementById('popItem3').classList.remove('posRightOut');
      }
      if(numberOfItems > 3) {
        setTimeout( function() { 
          document.getElementById('popItem4').classList.add('pos4');
          document.getElementById('popItem4').classList.remove('posRightOut');
        },500);
      }
      if(numberOfItems > 4) {
        setTimeout( function() { 
          document.getElementById('slideRight').classList.add('show');
        }, 1000);
      }
    })

    this.inview.observe('div[data-blog]', (el) => {
      let numberOfItems = el.dataset.blog;
      if(numberOfItems > 0) {
        document.getElementById('blogItem1').classList.add('pos1');
        document.getElementById('blogItem1').classList.remove('posRightOut');
      }
      if(numberOfItems > 1) {
        setTimeout( function() { 
          document.getElementById('blogItem2').classList.add('pos2');
          document.getElementById('blogItem2').classList.remove('posRightOut');
        },400);
      }
      if(numberOfItems > 2) {
        setTimeout( function() { 
          document.getElementById('blogItem3').classList.add('pos3');
          document.getElementById('blogItem3').classList.remove('posRightOut');
        },800);

        setTimeout( function() { 
          document.getElementById('slideRightBlog').classList.add('show');
        }, 1000);
      }
    })

    this.inview.observe('div[data-about]', (el) => {
      document.getElementById('aboutContainer').classList.add('show');
    })
  }

  async favoritesData () {
    let response = await new Xhr().get('/favorites/get')
    this.dispatcher.fire('favorites.loaded', response)
  }

  handleGlobalClicks () {
    document.addEventListener('mousedown', ({ target }) => {
      !containedIn(target, 'basket') && this.dispatcher.fire('basket.dropdown.close')
    })
  }
}
